import { Navigate } from "react-router-dom";
import { useEffect } from "react";

// Matches the keys Login.jsx sets on successful login:
// localStorage.setItem("token", data.access_token)
// localStorage.setItem("user", JSON.stringify(data.user))
function ProtectedRoute({ children }) {

    const isAuthenticated = !!localStorage.getItem("token");

    // After logout, Header does a full page navigation
    // (window.location.href = "/"). If the user then presses Back,
    // some browsers restore the previous page from bfcache -- a
    // frozen snapshot -- without re-running React, so this auth
    // check never re-fires. Forcing a reload on a bfcache restore
    // makes the app re-mount and re-check localStorage.
    useEffect(() => {

        const handlePageShow = (event) => {

            if (event.persisted) {

                window.location.reload();

            }

        };

        window.addEventListener("pageshow", handlePageShow);

        return () => window.removeEventListener("pageshow", handlePageShow);

    }, []);

    if (!isAuthenticated) {

        return <Navigate to="/" replace />;

    }

    return children;

}

export default ProtectedRoute;